import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enResource from './locales/strings-en';
import jaResource from './locales/strings-ja';
import enRemediations from './locales/remediations-en';
import jaRemediations from './locales/remediations-ja';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enResource,
        remediations: enRemediations,
      },
      ja: {
        translation: jaResource,
        remediations: jaRemediations,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    nonExplicitWhitelist: true,
    whitelist: ['en', 'ja'],

    debug: false,

    keySeparator: '.', // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    returnNull: false,
    returnObjects: true, // Allow lookups to return complex objects in addition to simple strings (used by remediations)
  });

export default i18n;
